import { render } from 'preact'
import "./styles/main.css"
import App from './app.tsx'
import {useDarkMode} from "usehooks-ts";
import {useEffect} from "react";
import {TimeZoneProvider} from "@/hooks/useTimeZone.tsx";
import {FormatContextProvider} from "@/hooks/useFormat.tsx";
import {CurrentCityProvider} from "@/hooks/useCurrentCity.tsx";
import {ErrorBoundary} from "react-error-boundary";
import {Error} from "@/components/ui/Error.tsx";

type TypeMode = "add" | "remove"

export const toggleMode = (type: TypeMode, className: string = "dark") => {
    document.body.classList[type](className)
}

function Main() {
    const { isDarkMode } = useDarkMode()

    useEffect(() => {
        isDarkMode ? toggleMode("add") : toggleMode("remove")
    }, [isDarkMode]);

    return <App />
}

render(<ErrorBoundary fallback={<Error />}>
    <TimeZoneProvider>
        <FormatContextProvider>
            <CurrentCityProvider>
                <Main />
            </CurrentCityProvider>
        </FormatContextProvider>
    </TimeZoneProvider>
</ErrorBoundary>, document.getElementById('app')!)
